<template>
  <section class="referral-list">
    <h2 class="section-title">直推列表</h2>
    <ul v-if="addresses.length" class="list">
      <li
        v-for="(addr, index) in addresses"
        :key="`${addr}-${index}`"
        class="item"
        :title="addr"
      >
        {{ formatAddr(addr) }}
      </li>
    </ul>
    <p v-else class="empty-tip">{{ emptyText }}</p>
  </section>
</template>

<script>
export default {
  name: "ReferralListSection",
  props: {
    addresses: {
      type: Array,
      required: true,
    },
    emptyText: {
      type: String,
      default: "暂无直推地址（连接钱包后展示）",
    },
  },
  methods: {
    formatAddr(addr) {
      const s = String(addr || "");
      if (!s) return "—";
      return this.$utils.shortenAddress(s) || s;
    },
  },
};
</script>

<style lang="scss" scoped>
.referral-list {
  padding-bottom: 48px;
}

.section-title {
  margin: 0 0 24px;
  font-size: 32px;
  font-weight: 600;
  color: #1a1a1a;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #eee;
  background: #fff;
}

.item {
  padding: 24px 28px;
  font-size: 24px;
  line-height: 1.4;
  color: #333;
  word-break: break-all;
  border-bottom: 1px solid #f0f0f0;
}

.item:last-child {
  border-bottom: none;
}

.empty-tip {
  margin: 0;
  padding: 28px 24px;
  font-size: 24px;
  line-height: 1.45;
  color: #8c8c8c;
  text-align: center;
  border-radius: 12px;
  border: 1px solid #eee;
  background: #fafafa;
}
</style>
